import { RefObject, useEffect } from "react";

const useClickOutside = (ref: RefObject<HTMLElement>, callback: () => void) => {
  const handleClick = (e: Event) => {
    if (ref.current && !ref.current.contains(e.target as Node)) {
      callback();
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClick);
    document.addEventListener("focusin", handleClick);

    return () => {
      document.removeEventListener("click", handleClick);
      document.removeEventListener("focusin", handleClick);
    };
  });
};
export default useClickOutside;
